<template>
  <div class="container py-32 px-20 flex gap-20">
    <filter-button></filter-button>
    <sort-button></sort-button>
  </div>
</template>
<script>
import FilterButton from './FilterButton'
import SortButton from './Universal/SortButton.vue'

export default {

  components: {
    FilterButton,
    SortButton,
  },
}
</script>
